import { persistReducer, persistStore } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

import reducers from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  // "user" is excluded so a stale access token never rehydrates from
  // localStorage; "authStatus" is excluded so AuthRoutes always waits for
  // AuthBootstrap's fresh silent-refresh check instead of trusting a
  // persisted "checked: true" from a previous page load.
  blacklist: ["user", "authStatus"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
